import { Avatar, Checkbox, Grid, Grid2, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Btn from "../../../Components/Ui_elements/Btn";
import Loader from "../../../Components/Ui_elements/Loader";
import dayjs from "dayjs";
import TextFieldComponent from "../../../Components/TextFieldComponent";
import AddIcon from '@mui/icons-material/Add';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { clientinvoiceSave, getClientScoopData } from "../../../redux/Thunk/InvoiceModule/InvoiceThunk";
import PopupModal from "../../../Components/Ui_elements/PopupModal";
import DeleteIcon from '@mui/icons-material/Delete';
import GenericTable from "../../../Components/Ui_elements/GenericTable";
import { invoiceWithSettings } from "../../../redux/Thunk/ReportModule/ReportThunk";
import { normalizeNumber, localizeNumber, isValidNumber } from "../../../Helper/generalhelper";
import { parseIMobile } from "../../../Helper/phone";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import { showSnackbar } from "../../../redux/Slice/snackbar/snackbarSlice";
const CreateNewInvoiceClient = () => {
    const { user } = useSelector((state) => state?.root?.authUser);
    const { invoice_with_settings } = useSelector((state) => state.root.ReportModule);
    const { client_scoop_invoice_selection } = useSelector((state) => state.root.InvoiceModule);
    const { loading } = useSelector((state) => state.root.loading);
    const [openModal, setOpenModal] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const [selectedScoopIds, setSelectedScoopIds] = useState([]);
    const [dueDate, setDueDate] = useState();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Form state management
    const [formData, setFormData] = useState({
        date: dayjs().format('YYYY-MM-DD'),
        description: '',
        description_value: '',
        notes: ''
    });

    let phoneNumber = "";
    try {
        const phoneObj = JSON.parse(invoice_with_settings?.settingData?.companyPhone || "{}");
        phoneNumber = phoneObj?.mobileNumber || "";
    } catch (err) {
        phoneNumber = invoice_with_settings?.settingData?.companyPhone || "";
    }

    const bankInfo = invoice_with_settings?.data?.[0]?.matchBankInfo || {};
    const [localScoop, setLocalScoop] = useState([]);
    useEffect(() => {
        setDueDate(formData.date ? dayjs(formData.date).add(invoice_with_settings?.data?.[0]?.number_of_days, 'day').format('DD.MM.YYYY') : '');
    }, [formData.date])
    useEffect(() => {
        if (invoice_with_settings?.data) {
            const initializedScoop = invoice_with_settings.data.map(item => {
                const newItem = {
                    ...item,
                    scoop_value: localizeNumber(item.scoop_value) || ''
                };
                return newItem;
            });

            setLocalScoop(initializedScoop);
            setSelectedScoopIds(initializedScoop.map(i => i.itemId))
        }
        else if (invoice_with_settings && !invoice_with_settings.data) {
            navigate('/client/invoice-client-projects');
        }
    }, [invoice_with_settings, navigate]);

    const address = JSON.parse(invoice_with_settings?.data?.[0]?.companyAddressDtl || "[]");
    const locality = address.find(item => item.id === "address1_locality")?.value || "";
    const postalCode = address.find(item => item.id === "address1_postal_code")?.value || "";
    const addressCountry = address.find(item => item.id === "address1_country")?.value || "";
    // const dueDate = invoice_with_settings?.data?.[0]?.invoice_no_of_days
    //     ? dayjs().add(invoice_with_settings?.data?.[0]?.invoice_no_of_days, 'day').format('DD.MM.YYYY')
    //     : 'N/A';
    const dueDateForPayloadFormate = invoice_with_settings?.data?.[0]?.invoice_no_of_days
        ? dayjs().add(invoice_with_settings?.data?.[0]?.invoice_no_of_days, 'day').format('YYYY-MM-DD')
        : 'N/A';

    const mobileParsed = parseIMobile(user?.iMobile);
    // Safe choice: use canonical if parseable, otherwise keep raw.
    const mobileNumber = mobileParsed?.formattedMobileNumber || mobileParsed?.rawMobileNumber || "";
    const senderContactName = [user?.vFirstName, user?.vLastName]
        .map(v => (typeof v === "string" ? v.trim() : ""))
        .filter(Boolean)
        .join(" ");
    const showContactDetails = Number(invoice_with_settings?.settingData?.[0]?.server_no) === 2;
    const showTelephone = showContactDetails;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleScoopValueChange = (index, value) => {
        setLocalScoop(prevScoop => {
            const updatedScoop = [...prevScoop];
            updatedScoop[index] = {
                ...updatedScoop[index],
                scoop_value: value
            };
            return updatedScoop;
        });
    };

    const handleDeleteRow = (index) => {
        setLocalScoop(prevScoop => {
            if (prevScoop.length <= 1) {
                dispatch(showSnackbar({
                    message: "Cannot delete the last invoice item",
                    type: "error",
                }))
                return prevScoop; // Don't update
            }

            const updatedScoop = [...prevScoop];
            updatedScoop.splice(index, 1);
            return updatedScoop;
        });
    };


    const calculateValues = () => {
        const scoopSubtotal = localScoop.reduce((acc, item) => {
            const value = parseFloat(normalizeNumber(item.scoop_value)) || 0;
            return acc + value;
        }, 0);

        const descriptionValue = parseFloat(normalizeNumber(formData.description_value) || 0);
        const subtotal = scoopSubtotal + descriptionValue;
        const taxRate = parseFloat(invoice_with_settings?.data?.[0]?.tax_rate || 0);
        const tax = (subtotal * taxRate) / 100;
        const total = subtotal + tax;

        return {
            subtotal: subtotal.toFixed(2),
            tax: tax.toFixed(2),
            total: total.toFixed(2)
        };
    };

    const { subtotal, tax, total } = calculateValues();

    const handleSave = () => {
        const payload = {
            invoice_type: "save",
            customer_id: invoice_with_settings?.data?.[0]?.clientId,
            scoop_id: JSON.stringify(localScoop.map(item => ({ id: item.itemId }))),
            payment_type: invoice_with_settings?.data?.[0]?.matchBankInfo?.payment_method,
            invoice_number: `${invoice_with_settings?.settingData?.[0]?.invoiceNoPrefix}${String(invoice_with_settings.data?.[0]?.invoiceCount + 1).padStart(6, '0')}`,
            custom_invoice_number: `${invoice_with_settings?.settingData?.[0]?.invoiceNoPrefix}${String(invoice_with_settings.data?.[0]?.invoiceCount + 1).padStart(6, '0')}`,
            invoice_number_max: invoice_with_settings.data?.[0]?.invoiceCount + 1,
            vat: invoice_with_settings.data?.[0]?.tax_rate || 0,
            item_total: subtotal.toString(),
            Invoice_cost: total,
            invoice_date: formData.date,
            invoice_due_date: dueDateForPayloadFormate,
            scoop_additional_detail: formData?.description,
            scoop_additional_price: normalizeNumber(formData?.description_value),
            sender_contact: senderContactName,
            sender_phone: mobileNumber,
            sender_email: user?.vEmailAddress,
            created_by: user?.iUserId,
            inv_notes: formData.notes,
            vat_amount: tax,
            items: localScoop.map(item => ({
                id: item.itemId,
                value: normalizeNumber(item.scoop_value)
            }))
        };

        dispatch(clientinvoiceSave(payload)).then((res) => {
            if (res?.payload?.status === 200) {
                navigate(`/viewinvoice/${res?.payload?.data?.invoice_id}`);
            }
        });
    };

    const handleAddInvoice = () => {

        const payload = {
            id: selectedScoopIds?.map(id => ({ id }))
        };
        // Dispatch the action with the formatted payload
        dispatch(invoiceWithSettings(payload))
            .then((response) => {
                setOpenModal(false);
            })
            .catch((error) => {
                console.error("Invoice creation failed", error);
                // Optionally show error to user
            });

    }
    const handleAddData = () => {
        setOpenModal(true);
        dispatch(getClientScoopData(invoice_with_settings?.data?.[0]?.clientId))
    }



    const handleCheckboxChange = (itemId) => {
        setSelectedScoopIds((prevSelected) =>
            prevSelected.includes(itemId)
                ? prevSelected.filter((id) => id != itemId) // Remove if already selected
                : [...prevSelected, itemId] // Add if not selected
        );
    };

    const columns = [
        {
            name: "itemId",
            label: "#",
            sortable: false,
            options: {
                sort: false,
                customHeadLabelRender: () => (
                    <Checkbox
                        checked={
                            selectedScoopIds.length > 0 &&
                            selectedScoopIds.length === client_scoop_invoice_selection?.length
                        }
                        indeterminate={
                            selectedScoopIds.length > 0 &&
                            selectedScoopIds.length < client_scoop_invoice_selection?.length
                        }
                        onChange={(e) => {
                            if (e.target.checked) {
                                // Select all scoop IDs
                                const allScoopIds = client_scoop_invoice_selection?.map(item => item.itemId) || [];
                                setSelectedScoopIds(allScoopIds);
                            } else {
                                // Clear selection
                                setSelectedScoopIds([]);
                            }
                        }}
                    />
                ),
                customBodyRender: (_, tableMeta) => {
                    // const itemId = client_scoop_invoice_selection?.[tableMeta.rowIndex]?.itemId;
                    const itemId = tableMeta.rowData[0];
                    // const scoopId = filterscoopReport?.data?.data[tableMeta.rowIndex]?.scoopId;
                    return (
                        <Checkbox
                            checked={selectedScoopIds.includes(itemId)}
                            onChange={() => handleCheckboxChange(itemId)}
                        />
                    );
                },
                setCellProps: () => ({ style: { width: "50px" } }),
            },
        },
        {
            name: "orderNumber",
            label: "Scoop Number",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const item_number = client_scoop_invoice_selection?.[tableMeta.rowIndex]?.item_number
                    return (
                        <Typography>
                            {value} - {String(item_number).padStart(3, '0')}
                        </Typography>
                    )
                }

            }
        },
        { name: "itemPonumber", label: "PO Number" },
        {
            name: "totalAmount", label: "Price", options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <Typography>
                            {localizeNumber(value)}
                        </Typography>
                    )
                }
            }
        },
        { name: "itemDuedate", label: "Due date" },
        {
            name: 'itemStatus',
            label: 'Status',
            options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <Box display="flex" alignItems="center">
                            <span style={{
                                color: value === 'Approved' ? 'green' : 'orange',
                                marginRight: '8px'
                            }}>
                                ●
                            </span>
                            {value}
                        </Box>
                    );
                }
            }
        },];

    const data = client_scoop_invoice_selection
        ?.filter(item => !localScoop.some(localItem => localItem.itemId === item.itemId))
        ?.map((item, index) => ({
            rowNumber: index + 1,
            ...item,
        }));
    useEffect(() => {
        if (!!formData.description || !!formData.description_value)
            setShowDescription(true)
    }, [formData.description, formData.description_value]);
    return (
        <>
            <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Grid item>
                    <Typography variant="h5">Invoice (Preview)</Typography>
                </Grid>
                <Grid item>
                    <Btn onClick={() => window.history.back()}>Back</Btn>
                </Grid>
            </Grid>


            {loading && !openModal ? <Loader /> : (
                <Paper elevation={2} sx={{ p: 3, maxWidth: 900, margin: "auto" }}>
                    {/* Header */}
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs>
                            <Typography variant="body2">
                                {invoice_with_settings?.settingData?.[0]?.company_name} |&nbsp;
                                {invoice_with_settings?.settingData?.[0]?.address1},&nbsp;
                                {invoice_with_settings?.settingData?.[0]?.postcode} {invoice_with_settings?.settingData?.[0]?.city},&nbsp;
                                {invoice_with_settings?.settingData?.[0]?.country}
                            </Typography>
                        </Grid>
                        <Grid item>
                            {invoice_with_settings?.settingData?.[0]?.logo_url && (
                                <img
                                    src={invoice_with_settings.settingData[0].logo_url}
                                    alt="Company Logo"
                                    style={{ width: 220, height: 110, objectFit: "contain" }}
                                />
                            )}
                        </Grid>
                    </Grid>

                    {/* Client Info */}
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="h6" fontWeight="bold">
                                {invoice_with_settings?.data?.[0]?.clientCompanyName || ""}
                            </Typography>
                            <Typography variant="body2">{invoice_with_settings?.data?.[0]?.companyAddress || ""}</Typography>
                            <Typography variant="body2">{locality}</Typography>
                            <Typography variant="body2">{postalCode}</Typography>
                            <Typography variant="body2">{addressCountry}</Typography>
                        </Grid>
                    </Grid>

                    {/* Contact Table */}
                    <TableContainer sx={{ mt: 4 }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                    {showContactDetails && <TableCell>Contact</TableCell>}
                                    {showTelephone && <TableCell>Telephone</TableCell>}
                                    {showContactDetails && <TableCell>Email</TableCell>}
                                    <TableCell>Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {showContactDetails && <TableCell>{senderContactName}</TableCell>}
                                    {showTelephone && <TableCell>{mobileNumber}</TableCell>}
                                    {showContactDetails && <TableCell>{user?.vEmailAddress || ""}</TableCell>}
                                    <TableCell>
                                        <DatePickerComponent
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            sx={{ width: "70%" }}
                                            isNotMandatory
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Invoice Number */}
                    <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
                        Invoice # {
                            `${invoice_with_settings?.settingData?.[0]?.invoiceNoPrefix}${String(invoice_with_settings.data?.[0]?.invoiceCount + 1).padStart(6, '0')}`
                        }
                    </Typography>

                    {/* Project List */}
                    <TableContainer sx={{ mt: 4 }}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <IconButton onClick={() => handleAddData()}><AddIcon /></IconButton>
                        </Box>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                    <TableCell>Project</TableCell>
                                    <TableCell>PO Number</TableCell>
                                    <TableCell>
                                        Price in {invoice_with_settings?.data?.[0]?.client_currency?.split(',')[0]?.trim()}
                                    </TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {localScoop?.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Box sx={{ whiteSpace: "pre-line" }}>
                                                <span>
                                                    {item?.orderNumber}-00{item?.item_number} | {item?.item_name}
                                                </span>
                                                {String(item?.accounting_inv_comment ?? "").trim() ? (
                                                    <>
                                                        {"\n"}
                                                        <span>
                                                            {item?.accounting_inv_comment}
                                                        </span>
                                                    </>
                                                ) : null}
                                            </Box>
                                        </TableCell>
                                        <TableCell>{item?.po_number}</TableCell>
                                        {/* <TableCell>{item?.scoop_value}</TableCell> */}
                                        <TableCell>
                                            <TextFieldComponent
                                                name={`scoop_value_${item.itemId}`}
                                                type="text"
                                                value={item.scoop_value}
                                                onChange={(e) => isValidNumber(e.target.value) && handleScoopValueChange(index, e.target.value)}
                                                sx={{ width: "70%" }}
                                                isNotMandatory={true}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleDeleteRow(index)}
                                                color="error"
                                                size="small"
                                            >
                                                <DeleteIcon /> {/* You'll need to import DeleteIcon from @mui/icons-material */}
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {showDescription && (
                                    <TableRow>
                                        <TableCell colSpan={2}>
                                            <TextFieldComponent
                                                name="description"
                                                type="text"
                                                value={formData.description}
                                                onChange={handleChange}
                                                placeholder="Description"
                                                sx={{ width: "70%" }}
                                                isNotMandatory
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextFieldComponent
                                                name="description_value"
                                                type="text"
                                                value={formData.description_value}
                                                onChange={(e) => isValidNumber(e.target.value) && setFormData(prev => ({ ...prev, description_value: e.target.value }))}
                                                placeholder="Value"
                                                sx={{ width: "70%" }}
                                                isNotMandatory
                                            />
                                        </TableCell>
                                    </TableRow>
                                )}

                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <Box
                                            onClick={() => setShowDescription(!showDescription)}
                                            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                        >
                                            <LocalOfferIcon sx={{ mr: 1 }} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Subtotal, Tax, Total */}
                    <TableContainer sx={{ mt: 4 }}>
                        <Table sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell><b>Subtotal excl. TAX</b></TableCell>
                                    <TableCell align="right"><b>{localizeNumber(subtotal)}</b></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{`${invoice_with_settings?.data?.[0]?.tax_rate != null ? localizeNumber(invoice_with_settings?.data?.[0]?.tax_rate) : '0,00'} % TAX` || `${invoice_with_settings?.data?.[0]?.tax_rate.toFixed(2)} % TAX`}</TableCell>
                                    <TableCell align="right">{localizeNumber(tax)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><b>Total Price</b></TableCell>
                                    <TableCell align="right"><b>{localizeNumber(total)}</b></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Notes Section */}
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="body1" gutterBottom><strong>Notes:</strong></Typography>
                        <TextFieldComponent
                            name="notes"
                            type="text"
                            value={formData.notes}
                            onChange={handleChange}
                            sx={{ width: "50%" }}
                            placeholder="Notes"
                            multiline
                            rows={3}
                            isNotMandatory
                        />
                        <Typography variant="body2" sx={{ whiteSpace: "pre-line", mt: 1 }}>
                            Payment for this invoice is due by {dueDate}
                        </Typography>
                    </Box>

                    {/* Bank Info */}
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="body1" gutterBottom><strong>Payment Details:</strong></Typography>
                        <Typography variant="body2">Bank Name: {bankInfo?.bank_name || ""}</Typography>
                        <Typography variant="body2">Bank Address: {bankInfo?.address || ""}</Typography>
                        <Typography variant="body2">Bank Holder: {bankInfo?.holder_name || ""}</Typography>
                        <Typography variant="body2">IBAN: {bankInfo?.iban || ""}</Typography>
                        <Typography variant="body2">SWIFT/BIC: {bankInfo?.swift_bic || ""}</Typography>
                    </Box>

                    {/* Footer */}
                    <Divider sx={{ my: 4, borderBottomWidth: 2, borderImage: "linear-gradient(to right, red, blue, green)", borderImageSlice: 1 }} />
                    <Grid container spacing={2} mt={2} justifyContent="space-between">
                        <Grid item xs={4}>
                            <Typography variant="body2" fontWeight="bold">{invoice_with_settings?.settingData?.[0].company_name}</Typography>
                            <Typography variant="body2">{invoice_with_settings?.settingData?.[0].address1}</Typography>
                            <Typography variant="body2">{invoice_with_settings?.settingData?.[0].postcode} {invoice_with_settings?.settingData?.[0].city}</Typography>
                            <Typography variant="body2">{invoice_with_settings?.settingData?.[0].country}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="body2">
                                Email: <Link to={`mailto:${invoice_with_settings?.settingData?.[0].work_email}`} underline="hover">{invoice_with_settings?.settingData?.[0].work_email}</Link>
                            </Typography>
                            <Typography variant="body2">
                                Web: <Link to={`https://${invoice_with_settings?.settingData?.[0].web_address}`} target="_blank" rel="noopener" underline="hover">{invoice_with_settings?.settingData?.[0].web_address}</Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={4} textAlign="right">
                            <Typography variant="body2" fontWeight="bold">VAT NUMBER:</Typography>
                            <Typography variant="body2">Foretaksregisteret:</Typography>
                            <Typography variant="body2">{invoice_with_settings?.settingData?.[0].vat_number}</Typography>
                        </Grid>
                    </Grid>

                    <Typography variant="body2" textAlign="center" mt={2}>
                        &copy; {invoice_with_settings?.settingData?.[0].copyright_text}
                    </Typography>

                    {/* Save Button */}
                    <Box sx={{ display: 'flex', spacing: 2, mt: 4, }}>
                        <Btn sx={{ mr: 2 }} onClick={handleSave}>Save Invoice</Btn>
                        <Btn variant="outlined" onClick={() => window.history.back()}>Cancel</Btn>

                    </Box>
                </Paper>
            )}
            <PopupModal
                open={openModal}
                maxWidth="lg"
                title="Add Invoice"
                handleClose={() => setOpenModal(false)}
                disableOverflow
                actions={
                    <>
                        <Btn onClick={handleAddInvoice}>Create Invoice</Btn>
                        <Btn variant="outlined" onClick={() => setOpenModal(false)}>Cancel</Btn>
                    </>
                }
            >
                <Typography variant='body1'>

                    <GenericTable
                        columns={columns}
                        data={data}
                        showAction={false}
                        displayColumns={4}
                        displayRows={10}
                    />
                </Typography>
            </PopupModal>
        </>
    );
};

export default CreateNewInvoiceClient;